import { useEffect, useState } from "react";
import { Copy, Phone, MessageCircle, Mail, MapPin, CheckCircle2 } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";

let cache = null;
export function useSiteConfig() {
  const [cfg, setCfg] = useState(cache);
  useEffect(()=>{
    if (cache) return;
    api.get("/config").then(r=>{ cache=r.data; setCfg(r.data); }).catch(()=>{});
  }, []);
  return cfg;
}

export function PixPaymentBox({ amount, description }) {
  const cfg = useSiteConfig();
  if (!cfg?.payments?.pix_key) return null;
  const pix = cfg.payments;
  const copy = () => { navigator.clipboard.writeText(pix.pix_key); toast.success("Chave Pix copiada"); };
  return (
    <Card className="p-5 gs-shadow border-slate-200" data-testid="pix-box">
      <div className="flex items-center justify-between">
        <div className="text-xs uppercase tracking-widest text-[#0D7C66] font-semibold">Pagamento via Pix</div>
        <div className="text-xs text-slate-500">{pix.pix_key_type}</div>
      </div>
      {amount && <div className="text-3xl font-extrabold mt-2" style={{fontFamily:"Plus Jakarta Sans"}}>R$ {amount}</div>}
      {description && <div className="text-sm text-slate-600 mt-1">{description}</div>}
      <div className="mt-4 rounded-xl bg-slate-50 border border-dashed border-slate-300 p-3 flex items-center justify-between gap-2">
        <div className="min-w-0">
          <div className="text-[10px] uppercase tracking-widest text-slate-500 font-semibold">Chave Pix ({pix.pix_key_type})</div>
          <div className="font-mono text-sm truncate" data-testid="pix-key">{pix.pix_key}</div>
          <div className="text-xs text-slate-500 mt-1">Beneficiário: <b>{pix.pix_beneficiary}</b></div>
        </div>
        <Button size="sm" data-testid="pix-copy" onClick={copy} className="bg-[#0D7C66] hover:bg-[#074E41]"><Copy className="w-4 h-4 mr-1"/>Copiar</Button>
      </div>
      <div className="mt-3 text-xs text-slate-500 flex items-start gap-1"><CheckCircle2 className="w-3.5 h-3.5 text-[#0D7C66] mt-0.5"/>Após o pagamento, envie o comprovante ao nosso WhatsApp para ativação imediata.</div>
    </Card>
  );
}

export function ContactStrip() {
  const cfg = useSiteConfig();
  if (!cfg?.contact) return null;
  const c = cfg.contact;
  const waLink = c.whatsapp ? `https://wa.me/55${c.whatsapp.replace(/\D/g,"")}` : "#";
  return (
    <div className="flex flex-wrap gap-4 text-sm">
      {c.phone && <a href={`tel:${c.phone.replace(/\D/g,"")}`} className="flex items-center gap-1 text-slate-300 hover:text-white" data-testid="contact-phone"><Phone className="w-4 h-4"/>{c.phone}</a>}
      {c.whatsapp && <a href={waLink} target="_blank" rel="noreferrer" className="flex items-center gap-1 text-slate-300 hover:text-white" data-testid="contact-whatsapp"><MessageCircle className="w-4 h-4"/>WhatsApp</a>}
      {c.email && <a href={`mailto:${c.email}`} className="flex items-center gap-1 text-slate-300 hover:text-white" data-testid="contact-email"><Mail className="w-4 h-4"/>{c.email}</a>}
    </div>
  );
}
